const getClearTime = (time) => new Date(`${time}Z`.replace(/ /g, 'T'));

const sortByTime = (a, b) => a.clearTime - b.clearTime;

const filterByDate = (time) => time >= Date.now();

const filterByExisting = (items, item) => items.find((existingItem) => item.name === existingItem.name);

export const filterBingoSchedule = ({ responses, gamesConfiguration }) => {
    const schedules = responses[0].data.siteSchedules;
    const { games, jackpots } = responses[1].data;

    const jackpotSorted = jackpots
        .sort((a, b) => a.jackpotAmount - b.jackpotAmount);

    const schedulesWithConfiguration = schedules
        .map((item) => {
            const jackpotObj = jackpotSorted
                .find(({ clubName, gameType }) => clubName === item.name && gameType === item.gameType) || {};

            const gameObj = games
                .find(({ gameName, gameType }) => gameName === item.name && gameType === item.gameType) || {};

            const gameParams = gamesConfiguration[item.name];
            const gameConfObj = gameParams?.bingoGameType === item.gameType
                ? gameParams
                : {};

            return {
                ...gameConfObj,
                ...gameObj,
                ...jackpotObj,
                ...item,
                clearTime: getClearTime(item.drawTime)
            };
        });

    return schedulesWithConfiguration
        .reduce((acc, item) => {
            if (!item.active || !filterByDate(item.clearTime) || filterByExisting(acc, item)) {
                return acc;
            }

            acc.push(item);

            return acc;
        }, [])
        .sort(sortByTime);
};
